import { mriCodeExists } from './apiService';

export const mriCodeValidate = async (str: string): Promise<string | null> => {
    // const mriCodeRegex = /^[A-Z0-9]+-\d{1,4}$/i;
    // return mriCodeRegex.test(str) ? str : null;

    return await mriCodeExists(str);
};
